module.exports = __webpack_public_path__ + "static/media/coming_soon_bg.aefaf549.png";